const belowTwenty = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen"
];

const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function twoDigitWords(value: number) {
  if (value < 20) {
    return belowTwenty[value];
  }

  return [tens[Math.floor(value / 10)], belowTwenty[value % 10]].filter(Boolean).join(" ");
}

function threeDigitWords(value: number) {
  const hundred = Math.floor(value / 100);
  const rest = value % 100;
  return [hundred ? `${belowTwenty[hundred]} Hundred` : "", rest ? twoDigitWords(rest) : ""].filter(Boolean).join(" ");
}

export function numberToIndianCurrencyWords(value: number | string | null | undefined) {
  const amount = Math.round(Math.abs(Number(value || 0)));

  if (!amount) {
    return "Zero Only";
  }

  const parts = [
    { label: "Crore", value: Math.floor(amount / 10000000) },
    { label: "Lakh", value: Math.floor((amount % 10000000) / 100000) },
    { label: "Thousand", value: Math.floor((amount % 100000) / 1000) },
    { label: "", value: amount % 1000 }
  ];

  const words = parts
    .filter((part) => part.value > 0)
    .map((part) => `${part.value < 100 ? twoDigitWords(part.value) : threeDigitWords(part.value)} ${part.label}`.trim())
    .join(" ");

  return `${words} Only`;
}
